import { useNavigate } from '@tanstack/react-router';
import { SandboxDetail } from '@frontend/wam-sales-demo-service';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function SalesDemoSandboxDetail() {
  const { sandboxId } = Route.useParams() as { sandboxId: string };
  const navigate = useNavigate();
  return (
    <Page
      title='Sales Demo - Sandbox'
      breadcrumbs={[{ label: 'Global Settings' }, { label: 'Sales Demo' }, { label: 'Sandbox' }]}
      maxWidth='100%'
    >
      <Container>
        <SandboxDetail
          sandboxId={sandboxId}
          onBack={() => navigate({ to: '/global-settings/sales-demo-sandboxes' as any })}
        />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/sales-demo-sandboxes_/$sandboxId',
  component: SalesDemoSandboxDetail,
  type: 'auth',
  locationRequired: false,
});
